var exports = {
  "uW": "PricingSection.module__section___bE9LTW",
  "E3": "PricingSection.module__toggleContainer___bE9LTW",
  "xQ": "PricingSection.module__footerContainer___bE9LTW",
  "$P": "PricingSection.module__scrollPromptContainer___bE9LTW",
  "Zq": "PricingSection.module__scrollPromptText___bE9LTW",
  "$O": "PricingSection.module__scrollPromptIcon___bE9LTW",
};

module.exports = exports;
